import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { AdminTopBar } from '@/components/admin/AdminTopBar';
import { Toaster } from '@/components/ui/sonner';

export const AdminShell = () => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div
      data-testid="admin-shell"
      className="min-h-screen flex bg-[hsl(var(--background))]"
    >
      <AdminSidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <AdminTopBar />
        <main
          data-testid="admin-shell-content"
          className="flex-1 px-3 sm:px-4 lg:px-6 py-4"
        >
          <Outlet />
        </main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
};
